import React from 'react';
import { Container, Card, Alert } from 'react-bootstrap';

const NuovoRefertoMedicinaInterna: React.FC = () => {
  return (
    <Container>
      <Card>
        <Card.Header>
          <h3>🩺 Nuovo Referto - Medicina Interna</h3>
        </Card.Header>
        <Card.Body>
          <Alert variant="warning">
            <h5>Refertazione non ancora disponibile</h5>
            <p>
              La sezione di refertazione per la specialistica di medicina interna è in fase di sviluppo.
            </p>
            <p className="mb-0">
              Per ora è disponibile solo la fatturazione per questa specialistica.
            </p>
          </Alert>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NuovoRefertoMedicinaInterna;
